<template>
  <svg
    viewBox="0 0 24 24"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
  </svg>
</template>

<style scoped>
.icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
}
</style>